import {PARTNER_DETAILS} from "../Actions/partnerDetailsAction";

export default (state = null, action) => {
    switch (action.type) {
        case PARTNER_DETAILS:
            return action.payload;
        default:
            return state;
    }
}
